import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const NotFound = () => {
  return (
    <>
      <section className="sec-wrap">
        <section className="sec-centent">
          <div className="sub-visual subv-5">
            <h1 style={{ margin: "100px" }}>
              404 Not Found
              <br /> Sorry, the page you are looking for does not exist.
            </h1>
          </div>
        </section>
      </section>
    </>
  );
};

export default NotFound;
